export default __webpack_public_path__ + "7f7cc1e29414553fc2ee75645d381f62.png";